import styled from 'styled-components'

export const VideoYoutubeWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding: 16px;
    @media only screen and (max-width: 768px) {
        padding: 0;
    }
`
export const ResponsiveVideo = styled.div`
    position: relative;
    width: 80%;
    padding-top: 45%;
    
    @media only screen and (max-width: 768px) {
        width: 100%;
        padding-top: 56.25%;
    }

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }
`